/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=5c529700"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5c529700&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/offical-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__